import { ApexPortfolio } from '../../../investment/components/account/ApexPortfolio';

export default function AccountPortfolio() {
    return <ApexPortfolio />;
}
